import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  placeholder: () => ({}),
  user: () => ({}),
  upgradesFlow: () => ({}),
  appSettings: () => ({}),
  makeItYours: () => ({}),
  vehicleDetails: () => ({}),
  vehiclesYouMightLike: () => ({})
});

export default rootReducer;
